import { get } from '../client'

export const getFidelizationAvailable = (nif, contractNumber) =>
  get(`orders/current_state?docNumber=${nif}&crmId=${contractNumber}`, true)
